import { render, staticRenderFns } from "./TinhThanhPho.vue?vue&type=template&id=b9245fee&scoped=true&"
import script from "./TinhThanhPho.vue?vue&type=script&lang=js&"
export * from "./TinhThanhPho.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9245fee",
  null
  
)

export default component.exports